import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import InputLabel from "@mui/material/InputLabel";
import { Box } from "../../Box/index.js";
import { Typography } from "../../Typography/index.js";
import { Icon } from "../../Icon/index.js";
import FormKnownValue_styles from "./FormKnownValue.styles.js";
const FormKnownValue = (t0)=>{
    const $ = c(17);
    const { label, value, verified: t1, caption } = t0;
    const verified = void 0 === t1 ? true : t1;
    const { classes } = FormKnownValue_styles();
    let t2;
    if ($[0] !== classes.label || $[1] !== label) {
        t2 = /*#__PURE__*/ jsx(InputLabel, {
            className: classes.label,
            children: label
        });
        $[0] = classes.label;
        $[1] = label;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = value || "";
    let t4;
    if ($[3] !== t3) {
        t4 = /*#__PURE__*/ jsx(Typography, {
            variant: "body2",
            children: t3
        });
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== verified) {
        t5 = verified && /*#__PURE__*/ jsx(Box, {
            ml: "8",
            display: "flex",
            alignItems: "center",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "check_circle_large",
                size: "16",
                color: "original.brand.primary"
            })
        });
        $[5] = verified;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t4 || $[8] !== t5) {
        t6 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            children: [
                t4,
                t5
            ]
        });
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== caption || $[11] !== classes.caption) {
        t7 = caption && /*#__PURE__*/ jsx("span", {
            className: classes.caption,
            children: caption
        });
        $[10] = caption;
        $[11] = classes.caption;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t2 || $[14] !== t6 || $[15] !== t7) {
        t8 = /*#__PURE__*/ jsxs(Box, {
            children: [
                t2,
                t6,
                t7
            ]
        });
        $[13] = t2;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    return t8;
};
export { FormKnownValue };
